import clsx from 'clsx'
import NextButton from 'components/common/NextButton'
import PrevButton from 'components/common/PrevButton'
import { useKeenSlider } from 'keen-slider/react'
import { FC, useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectIsLg } from 'store/ui'
import ImageModalDsk from './ImageModalDsk'
import Img from './Img'

interface ISliderProps {
  images: string[]
  aspectRatio: string
  isPage?: boolean
}

const options = {
  spacing: 12,
  perView: 1.1,
}

const ImageSlider: FC<ISliderProps> = ({
  images,
  aspectRatio,
  isPage,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [maxIndex, setMaxIndex] = useState(0)

  let [ref, slider] = useKeenSlider<HTMLDivElement>({
    slides: options,
    created(slider) {
      setMaxIndex(slider.track.details.maxIdx)
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
      setMaxIndex(slider.track.details.maxIdx)
    },
  })

  useEffect(() => {
    slider.current?.update()
  }, [slider])

  let [isDskModalOpen, setIsDskModalOpen] = useState(false)
  let [imgIdx, setImgIdx] = useState<number | null>(null)
  let handleModalOpen = useCallback((idx: number) => {
    setImgIdx(idx)
    setIsDskModalOpen(true)
  }, [])
  let isLg = useSelector(selectIsLg)

  let _images = images?.map((i) => ({
    src: i,
    height: 1,
    width: 1,
    blurDataURL: '',
  }))

  return (
    <>
      <div className='relative border-b border-lightGrey lg:border-none pb-5 lg:pb-0'>
        <div
          ref={ref}
          className='keen-slider h-full items-start flex overflow-hidden mx-auto max-w-[600px] lg:mx-0 max-h-[600px]'
        >
          {images.map((path, idx) => (
            <div
              key={path}
              className={clsx(
                'w-full flex-shrink-0 relative keen-slider__slide flex z-10',
                aspectRatio,
                {
                  'cursor-zoom-in': isPage && isLg,
                }
              )}
            >
              <Img
                onClick={
                  isLg && isPage
                    ? () => handleModalOpen(idx)
                    : undefined
                }
                skipLoading
                src={path}
                alt=''
                layout='fill'
                objectFit='contain'
                priority
              />
            </div>
          ))}
        </div>

        <div className='w-full max-w-[600px] mx-auto lg:mx-0 lg:w-[90%] flex justify-between items-center mt-5'>
          <PrevButton
            active={currentSlide > 0}
            onClick={() => slider.current?.prev()}
          />
          <div className='text-base2 leading-4'>{`${
            currentSlide + 1
          } / ${images.length}`}</div>
          <NextButton
            active={currentSlide < maxIndex}
            onClick={() => slider.current?.next()}
          />
        </div>
      </div>

      {isLg && isPage && (
        <ImageModalDsk
          idx={imgIdx ?? 0}
          images={_images}
          src={`${images[imgIdx ?? 0]}`}
          isOpen={isDskModalOpen}
          setIsOpen={setIsDskModalOpen}
          maxWidthClass='max-w-[600px]'
        />
      )}
    </>
  )
}

export default ImageSlider
